import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { BuildingIcon, PartyIcon, WineGlassIcon, GraduationIcon } from './Icons';
export function EventTypesSection() {
  const events = [{
    title: 'Eventos corporativos',
    description: 'Reuniones, presentaciones, desayunos de trabajo, cierres de año.',
    icon: <BuildingIcon className="w-8 h-8 text-olive" data-id="element-68" />
  }, {
    title: 'Eventos sociales',
    description: 'Cumpleaños, despedidas, brunchs, celebraciones familiares.',
    icon: <PartyIcon className="w-8 h-8 text-terracotta" data-id="element-69" />
  }, {
    title: 'Festejos íntimos',
    description: 'Reuniones en casa donde la presentación importa tanto como el sabor.',
    icon: <WineGlassIcon className="w-8 h-8 text-gold" data-id="element-70" />
  }, {
    title: 'Eventos especiales',
    description: 'Graduaciones, bautismos, comuniones, reuniones de colegio.',
    icon: <GraduationIcon className="w-8 h-8 text-brown-medium" data-id="element-71" />
  }];
  return <section id="eventos" className="py-24 bg-cream" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <FadeIn className="text-center mb-16" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-serif text-deep-brown mb-6" data-id="element-75">
            Para qué tipo de eventos trabajamos
          </h2>
          <div className="h-[2px] w-24 bg-gold mx-auto" data-id="element-76"></div>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-77">
          {events.map((event, index) => <StaggerItem key={index} data-id="element-78">
              <div className="bg-warm-white p-8 rounded-sm border border-sand hover:border-gold/50 hover:shadow-md transition-all duration-300 flex items-start gap-6 group cursor-default" data-id="element-79">
                <div className="bg-linen p-4 rounded-full group-hover:scale-110 transition-transform duration-300" data-id="element-80">
                  {event.icon}
                </div>
                <div data-id="element-81">
                  <h3 className="text-xl font-serif text-deep-brown mb-2" data-id="element-82">
                    {event.title}
                  </h3>
                  <p className="text-brown-medium leading-relaxed" data-id="element-83">
                    {event.description}
                  </p>
                </div>
              </div>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}